import React from "react";

const Stat_Average = () => {
  return (
    <div>
      <h1>Stat Average</h1>
    </div>
  );
};

export default Stat_Average;
